import { Fragment, useEffect } from 'react';
import ContentLoader from 'react-content-loader';
import {
  useNavigate,
  useParams } from 'react-router-dom';
import Container from '../../../../core/components/atoms/Container';
import { useExerciseResolution } from '../../hooks/useExerciseResolution';
import { useExerciseResolutionStore } from '../../stores/exerciseResolution';
import Player from '../../../../core/components/molecules/Player';
import { Typography } from '../../../../core/components/molecules/Typography';
import { disciplines } from '../../utils/disciplineHelper';

export default function ExerciseResolution() {
  const { exercicio } = useParams();
  const navigate = useNavigate();

  const { mutate, isLoading, isError } = useExerciseResolution();

  const { resolution } = useExerciseResolutionStore();

  useEffect(() => {
    if(exercicio) {
      mutate(exercicio);
    }
  }, [exercicio])


  if (isLoading) {
    return (
      <Container direction='col' gap='xxl' className='py-24 lg:py-18'>
        <ContentLoader />
      </Container>
    );
  }

  if (isError) {
    navigate('/');
    return <>Video não disponível</>;
  }

  if (!resolution) {
    return <></>;
  }

  const {defaultPlayer, vimeoID, sambatech_token, area} = resolution

  const token = defaultPlayer === "samba" ?
    sambatech_token : vimeoID

  const discipline = disciplines.find(it=>it.slug === area)

  return (
    <Fragment>
      <Container direction='col' gap='xxl' className='lg:pb-10'>

        <Typography type="title" size="h1">
          {discipline?.label}: Resolução de Exercício
        </Typography>

        <Player
          onFinish={() => {}}
          token={token}
          playerType={defaultPlayer}
          initialTime={0}
          className='h-[48vh] w-full'
        />

      </Container>
    </Fragment>
  );
}
